/* Acaure — chrome: drawer móvil + estado del header sobre hero */
(function () {
  "use strict";

  /* ---- Mobile drawer ---- */
  var nav = document.getElementById("acaureMobileNav");
  var scrim = document.getElementById("acaureScrim");
  function openNav() {
    if (!nav) return;
    nav.classList.add("is-open"); nav.setAttribute("aria-hidden", "false");
    if (scrim) scrim.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function shutNav() {
    if (!nav) return;
    nav.classList.remove("is-open"); nav.setAttribute("aria-hidden", "true");
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-acaure-menu-open]")) { e.preventDefault(); openNav(); }
    else if (e.target.closest("[data-acaure-menu-close]")) { e.preventDefault(); shutNav(); }
  });
  if (scrim) scrim.addEventListener("click", shutNav);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") shutNav(); });
  if (nav) nav.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", shutNav); });

  /* ---- Exponer --header-height (varios componentes de Dawn lo usan) ---- */
  var siteHeader = document.querySelector(".site-header");
  function setHeaderHeight() {
    if (siteHeader) document.documentElement.style.setProperty("--header-height", siteHeader.offsetHeight + "px");
  }
  setHeaderHeight();
  window.addEventListener("resize", setHeaderHeight);

  /* El header glass del Home (.is-over-hero) tiene apariencia ÚNICA y constante
     (vidrio esmerilado, texto oscuro). No cambia con el scroll → sin lógica de
     estados. Su estilo vive en acaure-base.css; el hero se desliza bajo él vía
     el margin-top que inyecta header.liquid. */
})();
